import Link from 'next/link'
import Logo from '@/components/common/Logo'
import { Menu } from '@/components/common/Menu'
import { Button } from '@/components/controls/Button'
import { SimplePersistentOffcanvas } from '@/components/offcanvas/SimplePersistentOffcanvas'
import { useState } from 'react'
import { useRouter } from 'next/router'
import { usePinable } from '@/hooks/Pinable'
import { useQuery } from '@/utils/url'

interface NavLink {
  href: { pathname: string; query: any; }
  label: string
}

interface SimpleNavbarProps {
  links: NavLink[]
  light?: boolean
}

export const SimpleNavbar: React.FC<SimpleNavbarProps> = ({ links, light = false }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false)
  const router = useRouter()
  const currentPath = router.pathname
  const isPinned = usePinable(1)

  const pinnedClass = () => {
    if (isPinned) {
      return 'simple-navbar--pinned'
    }

    return ''
  }

  return (
    <>
      <div className={`simple-navbar py-[14px] xl:py-[26px] fixed top-0 left-0 right-0 z-[99] w-full ${pinnedClass()}`}>
        <div className='container !max-w-[1320px] flex justify-between'>
          <Logo className='logo--primary !scale-[0.8] xl:!scale-[1]' link={'/'} color={light ? 'black' : 'white'}/>
          <div id="nav-primary" className="nav__wrapper nav__wrapper--mini">
            <nav>
              <ul className='flex flex-row gap-[32px]'>
                {links.map((link) => (
                  <li
                    key={link.href.pathname}
                    className={`hover-underline-animation transition-opacity duration-300 hover:opacity-100 hidden xl:block font-semibold font--accent whitespace-nowrap
                    ${currentPath === link.href.pathname ? 'opacity-100' : 'opacity-70'}
                    ${light ? 'color--black' : 'color--white'}
                  `}
                  >
                    <Link href={link.href} passHref>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
            <div className='ml-[80px] hidden xl:flex gap-[16px]'>
              <Button fullWidth={true} type="border-gray" height="md" fontSize={16} textCenter={true} href={useQuery(process.env.NEXT_PUBLIC_APP + 'login')} disableArrow={true} chevron={false} maxWidth={120}>Login</Button>
              <Button className='shrink-0' fullWidth={true} type="green" height="md" fontSize={16} textCenter={true} href={useQuery('/scientific-productivity-course')} disableArrow={true} chevron={false} maxWidth={170}>Free Course</Button>
            </div>
          </div>
          <div className='flex items-center xl:hidden'>
            <Menu withText={true} alwaysVisible={true}  menuColor={ light ? 'black' : 'white'} textColor={ light ? 'black' : 'white'} smallMenu={true} customCallback={() => {
              setShowOffcanvas(true)
            }}/>
          </div>
        </div>
      </div>
      <SimplePersistentOffcanvas show={showOffcanvas} onClose={() => setShowOffcanvas(false)}>
        <div className='flex flex-col justify-between h-full'>
          <nav className='pt-[24px]'>
            <ul className='color--black'>
              {links.map((link) => (
                <li
                  key={link.href.pathname}
                  className="flex text-[24px] mb-[18px] leading-[1.2] font-regular font--accent"
                >
                  <span className='arrow-right-sec mt-[14px] mr-[16px]'></span>
                  <Link href={link.href} passHref>
                    <a onClick={() => setShowOffcanvas(false)}>
                      {link.label}
                    </a>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className='flex flex-col gap-[16px]'>
            <Button fullWidth={true} type="white-with-border" height="lg" fontSize={18} textCenter={true} href={useQuery(process.env.NEXT_PUBLIC_APP + 'login')} disableArrow={true} chevron={false}>Login</Button>
            <Button fullWidth={true} type="green" height="lg" fontSize={18} textCenter={true} onClick={() => setShowOffcanvas(false)} href={useQuery('/scientific-productivity-course')} disableArrow={true} chevron={false}>Free Course</Button>
          </div>
        </div>
      </SimplePersistentOffcanvas>
    </>
  )
}
